import FileSaver from 'file-saver';

interface Response<T = any> {
  data: T;
  headers: any;
}

export const downloadXls = (response: Response, fileName?: string): void => {
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  FileSaver.saveAs(blob, fileName ?? response.headers.filename);
};
